import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";

export function invalidateTuitionRatePlanQueries(queryClient: QueryClient) {
  return queryClient.invalidateQueries({
    queryKey: [QueryKeys.TuitionRatePlans],
  });
}
